export const ANIMATED_TASK_ITEM_TOKENS = {
  svgViewBox: '0 0 20 20',
  pathD: 'M 0 4.5 L 3.182 8 L 10 0',
  pathLength: '1',
  strokeWidth: '1.7',
  pathTransform: 'translate(5.15 6.05)',
} as const
